"use client";

import { useState } from "react";
import { useAuth } from "../../context/auth";
import Support from "../../components/support/Support";
import FAQ from "../../components/fAQ/FAQ";
import Header from "../../components/header/Header";
import { faqByRole } from "../../components/fAQ/FaqByRole";
import "./HelpDeskSupport.css";

const HelpDeskPage = () => {
  const [activeTab, setActiveTab] = useState("support");

  const { user, isLoading } = useAuth();

  const selectedRole = user?.activeRole;

  if (isLoading || !selectedRole) return null;

  return (
    <div className="account-main-page">
      <Header />

      <div className="help-desk-page">
        <div className="help-desk-header">
          <h1 className="help-desk-title">Help Desk</h1>

          <div className="tab-buttons">
            <button
              className={`tab-button ${
                activeTab === "support" ? "active" : ""
              }`}
              onClick={() => setActiveTab("support")}
            >
              Support
            </button>

            <button
              className={`tab-button ${activeTab === "faq" ? "active" : ""}`}
              onClick={() => setActiveTab("faq")}
            >
              FAQ
            </button>
          </div>
        </div>

        <div className="help-desk-content">
          {activeTab === "support" && <Support />}

          {activeTab === "faq" && faqByRole[selectedRole] && (
            <FAQ data={faqByRole[selectedRole]} />
          )}
        </div>
      </div>
    </div>
  );
};

export default HelpDeskPage;
